// Adapter para la API de KPIs de errores
// Errors KPIs API adapter

import { apiClientWH } from '@shared/services/ApiClient';

export interface ErrorsKpisData {
  order_with_incorrect_address: number;
  order_with_payment_errors: number;
  order_with_unlinked_product: number;
  order_with_stock_errors: number;
  order_with_other_errors: number;
  total_orders_with_errors: number;
}

export interface ErrorsKpisResponse {
  success: boolean;
  data: ErrorsKpisData;
  message: string;
}

export interface ErrorsKpisParams {
  shop_id?: number;
}

export class ErrorsKpisApiAdapter {
  constructor(private httpClient: typeof apiClientWH) {}

  /**
   * GET /report/errors-kpis
   * Parámetros:
   * - shop_id (opcional): Shop ID to filter orders. Optional
   */
  async getErrorsKpis(params: ErrorsKpisParams = {}): Promise<ErrorsKpisResponse> {
    const response = await this.httpClient.get('/report/errors-kpis', {
      params: {
        shop_id: params.shop_id,
      },
    });

    return response.data;
  }
}
